/**
 * Main dashboard page - Routes to specific dashboards by role
 */
import { useAuth } from '@/contexts/AuthContext';
import { LoadingState } from '@/components/shared/LoadingState';
import { ClientDashboard } from './Dashboard/ClientDashboard';
import { BarberDashboard } from './Dashboard/BarberDashboard';
import { AdminDashboard } from './Dashboard/AdminDashboard';

export default function Dashboard() {
  const { user, customClaims, loading } = useAuth();

  if (loading) {
    return <LoadingState message="Cargando dashboard..." />;
  }

  // Route to specific dashboard based on role
  const userRole = customClaims?.role || user?.role;

  // Barber Dashboard
  if (userRole === 'barber') {
    return <BarberDashboard />;
  }

  // Client Dashboard
  if (userRole === 'client' || userRole === 'guest') {
    return <ClientDashboard />;
  }

  // Admin Dashboard (super_admin, franchise_owner, admin)
  return <AdminDashboard />;
}
